import Button from "common/Buttons/Button";
import { useContext, useEffect } from "react";
import {
  ModalItemContext,
  StrategyItemContext,
} from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import useCustomStrategyForm from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/useCustomStrategyForm";
import { displayResultMessage } from "utils/misc";
import useSharedCreateCustomStrategy from "@shared/features/configuration/useSharedCreateCustomStrategy";

const CreateCustomStrategyItem = ({ ...props }) => {
  const {
    onSave,
    customStrategyTemplate,
    customStrategiesItem,
    handleSelectItem,
    itemToEdit,
    setItemToEdit,
  } = useContext(StrategyItemContext)!;
  // @ts-ignore
  const { setOkButton } = useContext(ModalItemContext);
  const { updatedName, nameAndError, targetsComponent } = useCustomStrategyForm(
    { includeNameSelect: true }
  );

  const {
    handleSaveItem,
    createCustomStrategyLoading,
    editCustomStrategyLoading,
    createSubGroupCustomStrategyLoading,
    isCustomStrategyValid,
    targetsData,
  } = useSharedCreateCustomStrategy({
    updatedName,
    customStrategiesItem,
    customStrategyTemplate,
    accountId: props.accountId,
    isSignal: props.isSignal,
    subGroupIds: props.subGroupIds,
    orderType: props.orderType,
    itemToEdit,
    setItemToEdit,
    resetCustomStrategyTargets: props.resetCustomStrategyTargets,
    useCustomStrategyEndpoints: props.useCustomStrategyEndpoints,
    onSave,
    targets: props.targets,
    displayResultMessage,
    handleSelectItem,
  });

  const getOkButton = () => (
    <Button
      type="primary"
      onClick={handleSaveItem}
      disabled={!isCustomStrategyValid}
      loading={
        createCustomStrategyLoading ||
        editCustomStrategyLoading ||
        createSubGroupCustomStrategyLoading
      }
    >
      Save
    </Button>
  );

  useEffect(() => {
    setOkButton && setOkButton(getOkButton());
    return () => setOkButton(null);
  }, [
    targetsData.targets,
    updatedName,
    isCustomStrategyValid,
    createCustomStrategyLoading,
    createSubGroupCustomStrategyLoading,
    editCustomStrategyLoading,
  ]);

  return (
    <>
      <div style={{ marginBottom: 16 }}>{nameAndError}</div>
      {targetsComponent}
    </>
  );
};

export default CreateCustomStrategyItem;
